import { atom } from "recoil";

export const whyPageAtom = atom({
  key: "whyPageAtom",
  default: [],
});
